<template>
  <div class="content Tabs">

    <b-tabs card v-model="tabIndex">

      <b-tab v-if="currentUser.role=='Admin'" :title="lang.tab_Users" :title-link-class="textColors"
        :title-item-class="textColors" :active="tabIndex == 0">

        <UsersComponent :lang="lang.Users"></UsersComponent>

      </b-tab>
      <b-tab v-if="currentUser.role == 'Admin' && globalSettings.advancedPermissions" :title="lang.tab_Groups"
        :title-link-class="textColors" :title-item-class="textColors" :active="tabIndex == 1">

        <GroupsComponent :lang="lang.Groups"></GroupsComponent>

      </b-tab>

      <b-tab :title="lang.tab_Password" :title-link-class="textColors" :title-item-class="textColors"
        :active="tabIndex == 2">
        <b-container class="bv-example-row">

          <PasswordComponent :lang="lang.Password"></PasswordComponent>


        </b-container>
      </b-tab>
      <b-tab v-if="currentUser.role == 'Admin' && globalSettings.advancedPermissions" :title="lang.tab_LoginAudit" :title-link-class="textColors" :title-item-class="textColors" :active="tabIndex == 3">

        <DataTableFilteredOnApiLoginAuditComponent :lang="lang.LoginAudit"></DataTableFilteredOnApiLoginAuditComponent>

      </b-tab>
    </b-tabs>



  </div>

</template>
<script>
import { mapGetters } from 'vuex'



import UsersComponent from '@/components/shared/UsersComponent'
import PasswordComponent from '@/components/shared/PasswordComponent'
import GroupsComponent from '@/components/shared/GroupsComponent'
import DataTableFilteredOnApiLoginAuditComponent from '@/components/shared/DataTableFilteredOnApiLoginAuditComponent'

export default {
  name: "Content",
  components: {
    UsersComponent,
    PasswordComponent,
    GroupsComponent,
    DataTableFilteredOnApiLoginAuditComponent
  },
  props:{
    lang: Object,

  },
  data () {
    return {
      tabIndex: 0,
      options: [
        { item: 'Dark', name: 'Dark' },
        { item: 'Light', name: 'Light' },

      ],
      skinVariant: this.$store.getters.s_skinVariant,
    }
  },
  computed: {
    ...mapGetters([
      
      'globalSettings'
    ]),
    currentUser(){
      return this.$store.getters.currentUser;
    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },


  },
  created () {
    this.getTabIndex();

  },
  watch: {
    skinVariant: function (newVal) {
      
      this.$store.dispatch('changeSkinVariant', newVal);
    },
    tabIndex: function (newVal) {
      let obj = {};
      obj[this.$route.path + "__middle"] = newVal;

      this.$store.commit("SETTABDATA", obj);

      //####################
      this.$parent.$parent.$parent.switchButtons(newVal);

    }
  },
  
  methods: {
    getTabIndex() {
      

      if (this.$store.getters.tabData[this.$route.path + "__middle"] != undefined) {
        this.tabIndex = this.$store.getters.tabData[this.$route.path + "__middle"];
      } else {
        this.tabIndex = 0;
      }

    },
    

  },
  
  
}
</script>

<style scooped>



  .bv-example-row-max{
    max-width: 100%;
    padding-right: 0px;
    padding-left: 0px;
  }

  .card{
    margin: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Users/Views/Main/Middle/Content/Content.vue